import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-errors-list" }
const _hoisted_2 = {
  key: 0,
  class: "form-errors-list__title"
}
const _hoisted_3 = { class: "form-errors-list__list" }

import IconWarning from "@/assets/icons/icon__warning.svg"

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormErrorsList',
  props: {
    title: {},
    errorsList: {}
  },
  setup(__props: any) {

const props = __props;
// eslint-disable-next-line

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createVNode(_unref(IconWarning), { class: "icon" }),
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsList, (error) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "form-errors-list__item",
          key: error
        }, _toDisplayString(error), 1))
      }), 128))
    ])
  ]))
}
}

})